import { Component, ChangeDetectionStrategy, Input, ElementRef } from '@angular/core';

@Component({
  selector: 'lp2-spinner',
  template: ``,
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerComponent {
  @Input() public set size(size: number) {
    this.elRef.nativeElement.style.setProperty('--size', size.toString() + 'px');
  }
  @Input() public set color(color: string) {
    this.elRef.nativeElement.style.setProperty('--color', color);
  }

  constructor(private readonly elRef: ElementRef) { }
}



// WEBPACK FOOTER //
// ./ts/app/shared/spinner/spinner.component.ts